
























































































































































































import Vue, { PropType } from 'vue';
import {
  LabelQualityGoal,
  QualityGoalType,
} from '../../interfaces/types/QualityGoal';
import Input from '../common/Input/Input.vue';
import TextArea from '../common/TextArea/TextArea.vue';
import { numToKor } from '@/utils/parsers';

import DistributionGoalEdit from './QualityGoalEdit/DistributionGoalEdit.vue';

import CustomSelect from '../common/Select/CustomSelect.vue';
import Button from '../common/Button/Button.vue';
import { isCountInvalidUtil } from '@/utils/validator';
import QuantityGoalEdit from './QualityGoalEdit/QuantityGoalEdit.vue';
import MinAvgMaxGoalEdit from './QualityGoalEdit/MinAvgMaxGoalEdit.vue';
import TotalElementCountEdit from './QualityGoalEdit/TotalElementCountEdit.vue';
import CheckBox from '../common/CheckBox/CheckBox.vue';
import { showUnsupportedMessage } from '@/utils/demoUtils';

export default Vue.extend({
  props: {
    qualityGoal: {
      type: Object as PropType<QualityGoalType>,
      default: () => {
        return {
          name: 'qualityGoalName',
          description: 'description',
          qualityGoal: {
            metaQualityGoal: {},
          },
        } as QualityGoalType;
      },
    },
  },
  data: function (): {
    innerQualityGoalObj: QualityGoalType;
    selectedLabelGoalName: string;
    selectedMatcherLabel: string;
    editContainer: {
      distributionRate?: { [className: string]: number };
      classQuantity?: { [className: string]: number };
      minAvgMaxValue?: {
        minValue?: number;
        avgValue?: number;
        maxValue?: number;
      };
      totalElementCount?: number;
    };
    isAvailable: boolean;
    labelMatchObj?: { [className: string]: string };
    configuredLabelList: string[];
    reportOption: {
      showStandard: boolean;
      showEtc: boolean;
    };
  } {
    return {
      innerQualityGoalObj: { ...this.qualityGoal },
      selectedLabelGoalName: '',
      selectedMatcherLabel: '',
      editContainer: {
        distributionRate: undefined,
        classQuantity: undefined,
        minAvgMaxValue: undefined,
        totalElementCount: undefined,
      },
      isAvailable: false,
      labelMatchObj: undefined,
      configuredLabelList: Object.keys(
        this.qualityGoal.qualityGoal.labelQualityGoal,
      ).filter((label) => {
        return (
          this.qualityGoal.qualityGoal.labelQualityGoal[label].target !==
          undefined
        );
      }),
      reportOption: {
        showStandard: false,
        showEtc: false,
      },
    };
  },
  computed: {
    selectedLabelGoal: function (): LabelQualityGoal | undefined {
      if (!this.selectedLabelGoalName) {
        return undefined;
      }

      return {
        ...this.qualityGoal.qualityGoal.labelQualityGoal[
          this.selectedLabelGoalName
        ],
      };
    },
    possibleLabelList: function (): string[] {
      // !! 미완성 코드
      // TBD 현재 선택한 특성에 매치시킬 수 있는 라벨셋의 항목 가져오기
      const list: string[] = [];

      const type = this.selectedLabelGoal?.type;

      const labelAnalysis = this.$store.getters.labelAnalysisResult;

      for (const val in labelAnalysis) {
        const label = labelAnalysis[val];

        // condition, GraphView의 created 훅 로직을 참고 + 로직 분리 필요

        list.push(val);
      }

      return list;
    },
    quantityGoalNaturalLanguage: function (): string {
      if (
        !this.isCountInvalid(
          this.innerQualityGoalObj.qualityGoal.metaQualityGoal.quantityGoal,
        )
      )
        return numToKor(
          this.innerQualityGoalObj.qualityGoal.metaQualityGoal.quantityGoal,
        );
      else return '';
    },
  },
  watch: {
    selectedLabelGoal: function () {
      this.editContainer = {
        classQuantity: undefined,
        distributionRate: undefined,
        minAvgMaxValue: undefined,
        totalElementCount: undefined,
      };

      this.selectedMatcherLabel = '';
      this.isAvailable = false;
      this.labelMatchObj = undefined;

      if (!this.selectedLabelGoal) return;

      const method = this.selectedLabelGoal.method;
      switch (method) {
        case 'dist':
          this.editContainer.distributionRate =
            this.selectedLabelGoal.distributionRate;
          break;
        case 'classQuantity':
          this.editContainer.classQuantity =
            this.selectedLabelGoal.classQuantity;
          break;
        case 'minAvgMax':
        case 'arrLenMinAvgMax':
          this.editContainer.minAvgMaxValue = {
            minValue: this.selectedLabelGoal.minValue,
            avgValue: this.selectedLabelGoal.average,
            maxValue: this.selectedLabelGoal.maxValue,
          };
          break;
        case 'arrElCnt':
          this.editContainer.totalElementCount =
            this.selectedLabelGoal.elementCount;
          break;
      }
    },
  },
  methods: {
    // injected utility function. TBD: Mixin w/ typescript
    isCountInvalid(value: string | number) {
      return isCountInvalidUtil(value);
    },
    applyLabelGoalToReport() {
      if (!this.isAvailable) return;

      showUnsupportedMessage(this.$toast);

      // // innerQualityGoalObj에 변경점 반영
      // const selectedLabelObj =
      //   this.innerQualityGoalObj.qualityGoal.labelQualityGoal[
      //     this.selectedLabelGoalName
      //   ];

      // selectedLabelObj.target = this.selectedMatcherLabel;
      // selectedLabelObj.classes = this.labelMatchObj;
      // selectedLabelObj.reportOption = { ...this.reportOption };

      // // 변경 반영 대기 중 목록에 추가 (이미 존재한다면 갱신)
      // this.configuredLabelList = this.configuredLabelList.filter(
      //   (v) => v !== this.selectedLabelGoalName,
      // );
      // this.configuredLabelList.push(this.selectedLabelGoalName);

      // this.selectedLabelGoalName = '';
      // this.selectedMatcherLabel = '';
      // this.labelMatchObj = undefined;
    },
    clearSelectedLabelGoal() {
      if (confirm('저장하지 않은 정보가 사라집니다.')) {
        this.selectedLabelGoalName = '';
        this.selectedMatcherLabel = '';
        this.labelMatchObj = undefined;
      }
    },
    removeFromConfiguredList(targetConfiguredLabel: string) {
      showUnsupportedMessage(this.$toast);

      // if (confirm(`설정이 해제됩니다. (${targetConfiguredLabel})`)) {
      //   const selectedLabelObj =
      //     this.innerQualityGoalObj.qualityGoal.labelQualityGoal[
      //       targetConfiguredLabel
      //     ];

      //   selectedLabelObj.target = undefined;
      //   selectedLabelObj.classes = undefined;
      //   selectedLabelObj.reportOption = {
      //     showStandard: false,
      //     showEtc: false,
      //   };

      //   this.configuredLabelList = this.configuredLabelList.filter(
      //     (v) => v !== targetConfiguredLabel,
      //   );
      // }
    },
  },
  components: {
    Input,
    TextArea,
    CustomSelect,
    Button,
    DistributionGoalEdit,
    QuantityGoalEdit,
    MinAvgMaxGoalEdit,
    TotalElementCountEdit,
    CheckBox,
  },
});
